// extracted by mini-css-extract-plugin
module.exports = {"contents":"bf-z","sectionHeading":"cf-z"};